/**
 * 平台收款账户 | 分账账户 | 账户划转 | 虚拟账户 | 分账对账单
 */
import Net from '../net';

const NAME = '[AccountApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === AdminAccount === **/
/** account/detail-of-platform
 * @param {Object} data
*/
export async function getAdminAccountDetail(data = {}) {
  Log('getAdminAccountDetail data:', data)
  try {
    const res = await Net.http('account/detail-of-platform', { data })
    Log('getAdminAccountDetail res:', res)
    return res
  } catch (err) {
    Log('getAdminAccountDetail err:', err)
    throw err
  }
}

/** account/update
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.pay_config
*/
export async function updateAdminAccount(data = {}) {
  Log('updateAdminAccount data:', data)
  try {
    const res = await Net.http('account/update', { data })
    Log('updateAdminAccount res:', res)
    return res
  } catch (err) {
    Log('updateAdminAccount err:', err)
    throw err
  }
}

/** account/platform-transfer-out
 * @param {Object} data
 * @param {*} data.money
*/
export async function adminAccountPlatformTransferOut(data = {}) {
  Log('adminAccountPlatformTransferOut data:', data)
  try {
    const res = await Net.http('account/platform-transfer-out', { data })
    Log('adminAccountPlatformTransferOut res:', res)
    return res
  } catch (err) {
    Log('adminAccountPlatformTransferOut err:', err)
    throw err
  }
}


/** === ClearingAccount === **/
/** clearing-account/save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.clearing_account_id
 * @param {*} data.name
 * @param {*} data.phone
 * @param {*} data.pay_config
 * @param {*} data.pay_method
 * @param {*} data.transfer_out_period
 * @param {*} data.transfer_remark
*/
export async function saveClearingAccount(data = {}) {
  Log('saveClearingAccount data:', data)
  try {
    const res = await Net.http('clearing-account/save', { data })
    Log('saveClearingAccount res:', res)
    return res
  } catch (err) {
    Log('saveClearingAccount err:', err)
    throw err
  }
}

/** clearing-account/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.name
 * @param {*} data.operator_id
*/
export async function getClearingAccountList(data = {}) {
  Log('getClearingAccountList data:', data)
  try {
    const res = await Net.http('clearing-account/list', { data })
    Log('getClearingAccountList res:', res)
    return res
  } catch (err) {
    Log('getClearingAccountList err:', err)
    throw err
  }
}

/** clearing-account/list-by-page
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.name
*/
export async function getClearingAccountListByOperator(data = {}) {
  Log('getClearingAccountListByOperator data:', data)
  try {
    const res = await Net.http('clearing-account/list-by-page', { data })
    Log('getClearingAccountListByOperator res:', res)
    return res
  } catch (err) {
    Log('getClearingAccountListByOperator err:', err)
    throw err
  }
}

/** clearing-account/list-all
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getClearingAccountListAll(data = {}) {
  Log('getClearingAccountListAll data:', data)
  try {
    const res = await Net.http('clearing-account/list-all', { data })
    Log('getClearingAccountListAll res:', res)
    return res
  } catch (err) {
    Log('getClearingAccountListAll err:', err)
    throw err
  }
}

/** clearing-account/list
 * @param {Object} data
 * @param {*} data.station_operator_id
*/
export async function getClearingAccountListAllByOperator(data = {}) {
  Log('getClearingAccountListAllByOperator data:', data)
  try {
    const res = await Net.http('clearing-account/list', { data })
    Log('getClearingAccountListAllByOperator res:', res)
    return res
  } catch (err) {
    Log('getClearingAccountListAllByOperator err:', err)
    throw err
  }
}

/** clearing-account/detail
 * @param {Object} data
 * @param {*} data.clearing_account_id
*/
export async function getClearingAccountDetail(data = {}) {
  Log('getClearingAccountDetail data:', data)
  try {
    const res = await Net.http('clearing-account/detail', { data })
    Log('getClearingAccountDetail res:', res)
    return res
  } catch (err) {
    Log('getClearingAccountDetail err:', err)
    throw err
  }
}

/** clearing-account/delete
 * @param {Object} data
 * @param {*} data.clearing_account_id
*/
export async function deleteClearingAccount(data = {}) {
  Log('deleteClearingAccount data:', data)
  try {
    const res = await Net.http('clearing-account/delete', { data })
    Log('deleteClearingAccount res:', res)
    return res
  } catch (err) {
    Log('deleteClearingAccount err:', err)
    throw err
  }
}

/** clearing-account/has-auto-confirm
 * @param {Object} data
*/
export async function clearingAccountHasAutoConfirm(data = {}) {
  Log('clearingAccountHasAutoConfirm data:', data)
  try {
    const res = await Net.http('clearing-account/has-auto-confirm', { data })
    Log('clearingAccountHasAutoConfirm res:', res)
    return res
  } catch (err) {
    Log('clearingAccountHasAutoConfirm err:', err)
    throw err
  }
}

/** clearing-account/set-auto-confirm
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.auto_confirm_method
*/
export async function setClearingAccountAutoConfirm(data = {}) {
  Log('setClearingAccountAutoConfirm data:', data)
  try {
    const res = await Net.http('clearing-account/set-auto-confirm', { data })
    Log('setClearingAccountAutoConfirm res:', res)
    return res
  } catch (err) {
    Log('setClearingAccountAutoConfirm err:', err)
    throw err
  }
}

/** clearing-account/set-auto-transfer-out
 * @param {Object} data
 * @param {*} data.id
*/
export async function setClearingAccountAutoTransfer(data = {}) {
  Log('setClearingAccountAutoTransfer data:', data)
  try {
    const res = await Net.http('clearing-account/set-auto-transfer-out', { data })
    Log('setClearingAccountAutoTransfer res:', res)
    return res
  } catch (err) {
    Log('setClearingAccountAutoTransfer err:', err)
    throw err
  }
}

/** clearing-account/add-receiver-to-ecommerce
 * @param {Object} data
 * @param {*} data.id
*/
export async function openClearingAccountWxSettle(data = {}) {
  Log('openClearingAccountWxSettle data:', data)
  try {
    const res = await Net.http('clearing-account/add-receiver-to-ecommerce', { data })
    Log('openClearingAccountWxSettle res:', res)
    return res
  } catch (err) {
    Log('openClearingAccountWxSettle err:', err)
    throw err
  }
}

/** clearing-account/delete-receiver-from-ecommerce
 * @param {Object} data
 * @param {*} data.id
*/
export async function closeClearingAccountWxSettle(data = {}) {
  Log('closeClearingAccountWxSettle data:', data)
  try {
    const res = await Net.http('clearing-account/delete-receiver-from-ecommerce', { data })
    Log('closeClearingAccountWxSettle res:', res)
    return res
  } catch (err) {
    Log('closeClearingAccountWxSettle err:', err)
    throw err
  }
}

/** clearing-account/reset-account
 * @param {Object} data
 * @param {*} data.clearing_account_id
 * @param {*} data.username
*/
export async function resetClearingAccountAccount(data = {}) {
  Log('resetClearingAccountAccount data:', data)
  try {
    const res = await Net.http('clearing-account/reset-account', { data })
    Log('resetClearingAccountAccount res:', res)
    return res
  } catch (err) {
    Log('resetClearingAccountAccount err:', err)
    throw err
  }
}

/** clearing-account/change-password
 * @param {Object} data
 * @param {*} data.old_password
 * @param {*} data.new_password
*/
export async function changeClearingAccountPassword(data = {}) {
  Log('changeClearingAccountPassword data:', data)
  try {
    const res = await Net.http('clearing-account/change-password', { data })
    Log('changeClearingAccountPassword res:', res)
    return res
  } catch (err) {
    Log('changeClearingAccountPassword err:', err)
    throw err
  }
}

/** clearing-account/refund-account
 * @param {Object} data
 * @param {*} data.account_id
 * @param {*} data.operator_id
*/
export async function clearingAccountOrderAccount(data = {}) {
  Log('clearingAccountOrderAccount data:', data)
  try {
    const res = await Net.http('clearing-account/refund-account', { data })
    Log('clearingAccountOrderAccount res:', res)
    return res
  } catch (err) {
    Log('clearingAccountOrderAccount err:', err)
    throw err
  }
}

/** operator/service-charge/account/update
 * @param {Object} data
 * @param {*} data.clearing_account_id
 * @param {*} data.operator_id
*/
export async function clearingAccountServiceAccount(data = {}) {
  Log('clearingAccountServiceAccount data:', data)
  try {
    const res = await Net.http('operator/service-charge/account/update', { data })
    Log('clearingAccountServiceAccount res:', res)
    return res
  } catch (err) {
    Log('clearingAccountServiceAccount err:', err)
    throw err
  }
}


/** === ClearingPayment === **/
/** pay/paging
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.target_id
 * @param {*} data.target_type
*/
export async function getClearingPaymentListByTransferId(data = {}) {
  Log('getClearingPaymentListByTransferId data:', data)
  try {
    const res = await Net.http('pay/paging', { data })
    Log('getClearingPaymentListByTransferId res:', res)
    return res
  } catch (err) {
    Log('getClearingPaymentListByTransferId err:', err)
    throw err
  }
}

/** account-transfer/query
 * @param {Object} data
 * @param {*} data.id
*/
export async function queryClearingPayment(data = {}) {
  Log('queryClearingPayment data:', data)
  try {
    const res = await Net.http('account-transfer/query', { data })
    Log('queryClearingPayment res:', res)
    return res
  } catch (err) {
    Log('queryClearingPayment err:', err)
    throw err
  }
}

/** pay/list-pay
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.clearing_trade_id
*/
export async function getClearingPaymentListByTradeId(data = {}) {
  Log('getClearingPaymentListByTradeId data:', data)
  try {
    const res = await Net.http('pay/list-pay', { data })
    Log('getClearingPaymentListByTradeId res:', res)
    return res
  } catch (err) {
    Log('getClearingPaymentListByTradeId err:', err)
    throw err
  }
}

/** pay/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.clearing_trade_id
*/
export async function getClearingPaymentListByTradeIdByOperator(data = {}) {
  Log('getClearingPaymentListByTradeIdByOperator data:', data)
  try {
    const res = await Net.http('pay/list', { data })
    Log('getClearingPaymentListByTradeIdByOperator res:', res)
    return res
  } catch (err) {
    Log('getClearingPaymentListByTradeIdByOperator err:', err)
    throw err
  }
}

/** pay/order-pay
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.outer_user_id
*/
export async function clearingPaymentOrderPay(data = {}) {
  Log('clearingPaymentOrderPay data:', data)
  try {
    const res = await Net.http('pay/order-pay', { data })
    Log('clearingPaymentOrderPay res:', res)
    return res
  } catch (err) {
    Log('clearingPaymentOrderPay err:', err)
    throw err
  }
}


/** === AccountTransfer === **/
/** account-transfer/paging
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.clearing_account_id
 * @param {*} data.confirm_platform
 * @param {*} data.status
 * @param {*} data.operator_pay_config_id
 * @param {*} data.channel
 * @param {*} data.transfer_method
 * @param {*} data.order_sn
 * @param {*} data.begin_money
 * @param {*} data.end_money
*/
export async function getAccountTransferList(data = {}) {
  Log('getAccountTransferList data:', data)
  try {
    const res = await Net.http('account-transfer/paging', { data })
    Log('getAccountTransferList res:', res)
    return res
  } catch (err) {
    Log('getAccountTransferList err:', err)
    throw err
  }
}

/** account-transfer/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getAccountTransferDetail(data = {}) {
  Log('getAccountTransferDetail data:', data)
  try {
    const res = await Net.http('account-transfer/detail', { data })
    Log('getAccountTransferDetail res:', res)
    return res
  } catch (err) {
    Log('getAccountTransferDetail err:', err)
    throw err
  }
}

/** account-transfer/refund
 * @param {Object} data
 * @param {*} data.id
*/
export async function accountTransferRefund(data = {}) {
  Log('accountTransferRefund data:', data)
  try {
    const res = await Net.http('account-transfer/refund', { data })
    Log('accountTransferRefund res:', res)
    return res
  } catch (err) {
    Log('accountTransferRefund err:', err)
    throw err
  }
}

/** account-transfer/stat
 * @param {Object} data
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function accountTransferStat(data = {}) {
  Log('accountTransferStat data:', data)
  try {
    const res = await Net.http('account-transfer/stat', { data })
    Log('accountTransferStat res:', res)
    return res
  } catch (err) {
    Log('accountTransferStat err:', err)
    throw err
  }
}

/** account-transfer/update-pay-config
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.pay_config
*/
export async function updateAccountTransferPayConfig(data = {}) {
  Log('updateAccountTransferPayConfig data:', data)
  try {
    const res = await Net.http('account-transfer/update-pay-config', { data })
    Log('updateAccountTransferPayConfig res:', res)
    return res
  } catch (err) {
    Log('updateAccountTransferPayConfig err:', err)
    throw err
  }
}

/** account-transfer/platform-confirm
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.transfer_method
*/
export async function accountTransferPlatformConfirmPass(data = {}) {
  Log('accountTransferPlatformConfirmPass data:', data)
  try {
    const res = await Net.http('account-transfer/platform-confirm', { data })
    Log('accountTransferPlatformConfirmPass res:', res)
    return res
  } catch (err) {
    Log('accountTransferPlatformConfirmPass err:', err)
    throw err
  }
}

/** account-transfer/batch-platform-confirm
 * @param {Object} data
 * @param {*} data.ids
 * @param {*} data.transfer_method
*/
export async function accountTransferBatchPlatformConfirm(data = {}) {
  Log('accountTransferBatchPlatformConfirm data:', data)
  try {
    const res = await Net.http('account-transfer/batch-platform-confirm', { data })
    Log('accountTransferBatchPlatformConfirm res:', res)
    return res
  } catch (err) {
    Log('accountTransferBatchPlatformConfirm err:', err)
    throw err
  }
}

/** account-transfer/platform-confirm-no-pass
 * @param {Object} data
 * @param {*} data.id
*/
export async function accountTransferPlatformConfirmNoPass(data = {}) {
  Log('accountTransferPlatformConfirmNoPass data:', data)
  try {
    const res = await Net.http('account-transfer/platform-confirm-no-pass', { data })
    Log('accountTransferPlatformConfirmNoPass res:', res)
    return res
  } catch (err) {
    Log('accountTransferPlatformConfirmNoPass err:', err)
    throw err
  }
}


/** === VirtualAccount === **/
/** account/list-by-user
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.user_id
 * @param {*} data.type
 * @param {*} data.channel
*/
export async function getVirtualAccountList(data = {}) {
  Log('getVirtualAccountList data:', data)
  try {
    const res = await Net.http('account/list-by-user', { data })
    Log('getVirtualAccountList res:', res)
    return res
  } catch (err) {
    Log('getVirtualAccountList err:', err)
    throw err
  }
}

/** account/list
 * @param {Object} data
 * @param {*} data.clearing_account_id
 * @param {*} data.operator_pay_config_id
*/
export async function getVirtualAccountListByAccount(data = {}) {
  Log('getVirtualAccountListByAccount data:', data)
  try {
    const res = await Net.http('account/list', { data })
    Log('getVirtualAccountListByAccount res:', res)
    return res
  } catch (err) {
    Log('getVirtualAccountListByAccount err:', err)
    throw err
  }
}

/** account/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getVirtualAccountDetail(data = {}) {
  Log('getVirtualAccountDetail data:', data)
  try {
    const res = await Net.http('account/detail', { data })
    Log('getVirtualAccountDetail res:', res)
    return res
  } catch (err) {
    Log('getVirtualAccountDetail err:', err)
    throw err
  }
}

/** account-money/paging
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.account_id
 * @param {*} data.subject
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function virtualAccountMoneyList(data = {}) {
  Log('virtualAccountMoneyList data:', data)
  try {
    const res = await Net.http('account-money/paging', { data })
    Log('virtualAccountMoneyList res:', res)
    return res
  } catch (err) {
    Log('virtualAccountMoneyList err:', err)
    throw err
  }
}

/** account/transfer-to-account
 * @param {Object} data
 * @param {*} data.from_account_id
 * @param {*} data.to_account_id
 * @param {*} data.money
*/
export async function virtualAccountTransfer(data = {}) {
  Log('virtualAccountTransfer data:', data)
  try {
    const res = await Net.http('account/transfer-to-account', { data })
    Log('virtualAccountTransfer res:', res)
    return res
  } catch (err) {
    Log('virtualAccountTransfer err:', err)
    throw err
  }
}

/** account/transfer-money
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.money
*/
export async function virtualAccountWithdraw(data = {}) {
  Log('virtualAccountWithdraw data:', data)
  try {
    const res = await Net.http('account/transfer-money', { data })
    Log('virtualAccountWithdraw res:', res)
    return res
  } catch (err) {
    Log('virtualAccountWithdraw err:', err)
    throw err
  }
}

/** account/recharge-account
 * @param {Object} data
 * @param {*} data.account_id
 * @param {*} data.price
 * @param {*} data.pay_method
*/
export async function createVirtualAccountOrder(data = {}) {
  Log('createVirtualAccountOrder data:', data)
  try {
    const res = await Net.http('account/recharge-account', { data })
    Log('createVirtualAccountOrder res:', res)
    return res
  } catch (err) {
    Log('createVirtualAccountOrder err:', err)
    throw err
  }
}

/** account/device-account-recharge
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.pay_method
 * @param {*} data.uids
*/
export async function createVirtualAccountOrderByDevice(data = {}) {
  Log('createVirtualAccountOrderByDevice data:', data)
  try {
    const res = await Net.http('account/device-account-recharge', { data })
    Log('createVirtualAccountOrderByDevice res:', res)
    return res
  } catch (err) {
    Log('createVirtualAccountOrderByDevice err:', err)
    throw err
  }
}


/** === ClearingStatement === **/
/** statement/stat
 * @param {Object} data
*/
export async function clearingStatementStat(data = {}) {
  Log('clearingStatementStat data:', data)
  try {
    const res = await Net.http('statement/stat', { data })
    Log('clearingStatementStat res:', res)
    return res
  } catch (err) {
    Log('clearingStatementStat err:', err)
    throw err
  }
}

/** statement/list/recent
 * @param {Object} data
 * @param {*} data.type
*/
export async function clearingStatementDoing(data = {}) {
  Log('clearingStatementDoing data:', data)
  try {
    const res = await Net.http('statement/list/recent', { data })
    Log('clearingStatementDoing res:', res)
    return res
  } catch (err) {
    Log('clearingStatementDoing err:', err)
    throw err
  }
}

/** statement/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.operator_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.type
*/
export async function getClearingStatementList(data = {}) {
  Log('getClearingStatementList data:', data)
  try {
    const res = await Net.http('statement/list', { data })
    Log('getClearingStatementList res:', res)
    return res
  } catch (err) {
    Log('getClearingStatementList err:', err)
    throw err
  }
}

/** statement/add-task
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.type
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function exportClearingStatement(data = {}) {
  Log('exportClearingStatement data:', data)
  try {
    const res = await Net.http('statement/add-task', { data })
    Log('exportClearingStatement res:', res)
    return res
  } catch (err) {
    Log('exportClearingStatement err:', err)
    throw err
  }
}

/** statement/add-vip-monthly-task
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.type
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function exportClearingStatementVip(data = {}) {
  Log('exportClearingStatementVip data:', data)
  try {
    const res = await Net.http('statement/add-vip-monthly-task', { data })
    Log('exportClearingStatementVip res:', res)
    return res
  } catch (err) {
    Log('exportClearingStatementVip err:', err)
    throw err
  }
}

/** statement/list/operator-recent
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function clearingStatementRecent(data = {}) {
  Log('clearingStatementRecent data:', data)
  try {
    const res = await Net.http('statement/list/operator-recent', { data })
    Log('clearingStatementRecent res:', res)
    return res
  } catch (err) {
    Log('clearingStatementRecent err:', err)
    throw err
  }
}

/** statement/list/vip-operator-recent
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function clearingStatementRecentVip(data = {}) {
  Log('clearingStatementRecentVip data:', data)
  try {
    const res = await Net.http('statement/list/vip-operator-recent', { data })
    Log('clearingStatementRecentVip res:', res)
    return res
  } catch (err) {
    Log('clearingStatementRecentVip err:', err)
    throw err
  }
}

/** statement/delete-task
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.type
*/
export async function deleteClearingStatementTask(data = {}) {
  Log('deleteClearingStatementTask data:', data)
  try {
    const res = await Net.http('statement/delete-task', { data })
    Log('deleteClearingStatementTask res:', res)
    return res
  } catch (err) {
    Log('deleteClearingStatementTask err:', err)
    throw err
  }
}
